export default __webpack_public_path__ + "static/01-01-reading-science-articles-60395c4431e192da6e0eab2b71982272.mp4";